import React from 'react';
import { SideBar } from './../../sidebar';
import { approveClient, deleteUser, getUserInfo, getUsers } from '../../../../models/users';
import DataTable from 'react-data-table-component';
import i18n from '../../../../i18n';
import { Modal } from 'react-bootstrap';
import { EditUser } from './../../helper/edit_user';
import { getLoggedUser } from '../../../../state/user';
import HeaderBanner from '../../../common/HeaderBanner';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import FilterSection from '../../../common/Filter';
import Tooltip from '../../../common/Tooltip';
import { ConfirmModal } from '../../../common/ConfirmModal';
import NewDropdown from '../../../common/NewDropDown';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../../utils/downloadFile';
import { apiUrl } from '../../../../constants/global';
import {
  AlertTriangle,
  CheckCircle2,
  Download,
  Expand,
  Eye,
  FileSpreadsheet,
  Printer,
  Shrink,
  Trash,
} from 'lucide-react';

const user = getLoggedUser();

export class ClientsList extends React.Component {
  constructor() {
    super();
    this.state = {
      update_popup: false,
      data: {},
      is_loading: false,
      users: [],
      hideSidebar: false,
      totalRows: 0,
      page: 1,
      limit: 15,
      search: {
        qtext: '',
      },
      showDelete: false,
      selectedUserId: null,
      deleteLoading: false,
      showApprove: false,
      selectedApproveId: null,
      approveLoading: false,
      exportLoading: false,
    };
    this.triggerReload = this.triggerReload.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.submitDelete = this.submitDelete.bind(this);
    this.submitApprove = this.submitApprove.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadAllUsers();
  }

  buildQuery() {
    const { page, limit, search } = this.state;
    const q = { page, limit, is_client: 1 };
    if (search.qtext) q.qtext = search.qtext;
    return new URLSearchParams(q).toString();
  }

  async loadAllUsers() {
    this.setState({ is_loading: true });
    const qstring = this.buildQuery();
    const response = await getUsers(qstring);
    if (response.success) {
      this.setState({
        users: response.data,
        totalRows: response.meta.total,
        is_loading: false,
      });
    } else {
      this.setState({ is_loading: false });
    }
  }

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      search: { ...prevState.search, [name]: value },
    }));
  };

  handleSearch() {
    this.setState({ page: 1 }, () => this.loadAllUsers());
  }

  handleClear() {
    this.setState({ search: { qtext: '' }, page: 1 }, () => this.loadAllUsers());
  }

  onChangePage(page) {
    window.scrollTo(0, 250);
    this.setState({ page }, () => this.loadAllUsers());
  }

  onChangeRowsPerPage(limit) {
    this.setState({ limit, page: 1 }, () => this.loadAllUsers());
  }

  async viewRow(id) {
    const response = await getUserInfo(id);
    let data = response.data;
    this.setState({ data, update_popup: true });
  }

  handleDelete = (row) => {
    this.setState({ selectedUserId: row.id, showDelete: true });
  };

  async submitDelete() {
    const { selectedUserId } = this.state;
    if (!selectedUserId) return;
    this.setState({ deleteLoading: true });
    try {
      const response = await deleteUser(selectedUserId);
      if (response.success) {
        toast.success('Client deleted successfully');
        this.loadAllUsers();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      this.setState({ deleteLoading: false, showDelete: false, selectedUserId: null });
    }
  }

  handleApprove = (row) => {
    this.setState({ selectedApproveId: row.id, showApprove: true });
  };

  async submitApprove() {
    const { selectedApproveId } = this.state;
    if (!selectedApproveId) return;
    this.setState({ approveLoading: true });
    try {
      const response = await approveClient(selectedApproveId);
      if (response.success) {
        toast.success('Approved the selected client');
        this.loadAllUsers();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      this.setState({ approveLoading: false, showApprove: false, selectedApproveId: null });
    }
  }

  triggerReload(opt) {
    if (opt) {
      this.loadAllUsers();
    }
  }


  getColumns = () => {
    const isAdmin = user?.role === 'A';
    return [
      {
        name: i18n.t('id'),
        selector: (row) => row.id,
        sortable: true,
        wrap: true,
        width: '80px',
      },
      {
        name: i18n.t('name'),
        selector: (row) => row.name,
        sortable: true,
        wrap: true,
      },
      {
        name: i18n.t('username'),
        selector: (row) => row.username,
        sortable: true,
        wrap: true,
      },
      {
        name: i18n.t('email'),
        selector: (row) => row.email,
        wrap: true,
      },
      {
        name: i18n.t('mobile'),
        selector: (row) => row.mobile,
        wrap: true,
        cell: (row) => `${row.country_code} ${row.mobile}`,
      },
      {
        name: i18n.t('status'),
        width: '140px',
        center: true,
        cell: (row) =>
          row.status === 1 ? (
            <span className="text-success d-flex align-items-center">
              <CheckCircle2 size={16} style={{ marginRight: '0.3rem' }} />
              {i18n.t('approved')}
            </span>
          ) : isAdmin ? (
            <button className="btn btn-success btn-sm" onClick={() => this.handleApprove(row)}>
              {i18n.t('approve')}
            </button>
          ) : (
            <span className="text-muted">{i18n.t('pending')}</span>
          ),
      },
      {
        name: i18n.t('Actions'),
        width: '110px',
        center: true,
        cell: (row) => (
          <div className="table-row">
            <Tooltip
              icon={Eye}
              tooltipText={i18n.t('view')}
              onClick={() => this.viewRow(row.id)}
              size={16}
              className="primary-color"
            />
            {isAdmin &&
              (row.role === 'A' ? (
                <span className="text-danger" style={{ marginLeft: '0.5rem' }}>
                  {i18n.t('not_allowed')}
                </span>
              ) : (
                <Tooltip
                  icon={Trash}
                  tooltipText={i18n.t('delete')}
                  onClick={() => this.handleDelete(row)}
                  size={16}
                  className="danger-color"
                />
              ))}
          </div>
        ),
      },
    ];
  };

  render() {
    const { users, is_loading, totalRows, deleteLoading, showDelete, approveLoading, showApprove, exportLoading, search } =
      this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('clients')} subtitle={i18n.t('clients_list_subtitle')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({ hideSidebar: !this.state.hideSidebar });
                        }}
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <FilterSection
                      loading={is_loading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="qtext"
                          type="text"
                          name="qtext"
                          value={search.qtext || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" "
                        />
                        <label htmlFor="qtext" className="floating-label">
                          {i18n.t('search_by_name_username_email_or_phone')}
                        </label>
                      </div>
                    </FilterSection>

                    <div className="Data-Listing">
                      {is_loading ? (
                        <TableSkeleton columns={7} rows={10} />
                      ) : users.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={users}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={totalRows}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_clients_available')}
                          actionText={i18n.t('refresh')}
                          onAction={() => this.loadAllUsers()}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* View/Edit client modal */}
        <Modal
          size="md"
          show={this.state.update_popup}
          onHide={() => this.setState({ update_popup: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t('view_edit_user')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditUser data={this.state.data} triggerReload={this.triggerReload} roles_needed={false} />
          </Modal.Body>
        </Modal>

        <ConfirmModal
          show={showDelete}
          onClose={() => this.setState({ showDelete: false, selectedUserId: null })}
          title={'Confirm Client Deletion'}
          titleIcon={<AlertTriangle size={22} color="#dc3545" />}
          message={'Are You Sure You Want to Delete This Client?'}
          onConfirm={this.submitDelete}
          onCancel={() => this.setState({ showDelete: false, selectedUserId: null })}
          confirmText={'Delete'}
          cancelText="Cancel"
          loading={deleteLoading}
        ></ConfirmModal>

        <ConfirmModal
          show={showApprove}
          onClose={() => this.setState({ showApprove: false, selectedApproveId: null })}
          title={'Confirm Client Approval'}
          titleIcon={<CheckCircle2 size={22} color="#28a745" />}
          message={'Are You Sure You Want to Approve This Client?'}
          onConfirm={this.submitApprove}
          onCancel={() => this.setState({ showApprove: false, selectedApproveId: null })}
          confirmText={'Approve'}
          cancelText="Cancel"
          loading={approveLoading}
        ></ConfirmModal>
      </React.Fragment>
    );
  }
}

export default ClientsList;